import { render, staticRenderFns } from "./RemovePost.vue?vue&type=template&id=369a5a14&scoped=true&"
import script from "./RemovePost.vue?vue&type=script&lang=js&"
export * from "./RemovePost.vue?vue&type=script&lang=js&"
import style0 from "./RemovePost.vue?vue&type=style&index=0&id=369a5a14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a5a14",
  null
  
)

export default component.exports